module.exports = __webpack_public_path__ + "static/img/Crait_Resource_09.d1dd9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180419/Crait_Resource_09.png
// module id = 256
// module chunks = 1